interface Props {
  children: React.ReactNode;
}

export const TabDisplayItemLabel: React.FC<Props> = ({ children }) => (
  <dt className="text-sm font-medium text-gray-500">{children}</dt>
);
